module.exports = __webpack_public_path__ + "assets/img/exclude.f6cfa115.png";